import { render, staticRenderFns } from "./pop-set-description.vue?vue&type=template&id=28a436e9&scoped=true"
import script from "./pop-set-description.vue?vue&type=script&lang=js"
export * from "./pop-set-description.vue?vue&type=script&lang=js"
import style0 from "./pop-set-description.vue?vue&type=style&index=0&id=28a436e9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a436e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\privateItem\\sct-shop\\sct-shop-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a436e9')) {
      api.createRecord('28a436e9', component.options)
    } else {
      api.reload('28a436e9', component.options)
    }
    module.hot.accept("./pop-set-description.vue?vue&type=template&id=28a436e9&scoped=true", function () {
      api.rerender('28a436e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/memberCard/components/pop-set-description.vue"
export default component.exports